import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight, faChevronLeft, faChevronRight, faHandshakeSimpleSlash, faMagnifyingGlass, faUsers, faXmark } from '@fortawesome/free-solid-svg-icons';
import "./knowledge.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { faBookmark, faCalendar, faEye, faHandshake, faUser } from '@fortawesome/free-regular-svg-icons';
import { Rating } from '@mui/material';
import { apiService } from '../../services/apiService';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';
import { Accordion } from 'react-bootstrap';
import { toast } from 'react-toastify';
function KnowledgeArticleBookmark() {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };
    const closeElement = () => {
        setIsVisible(false);
    };
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");

    const [catsloading, setCatsLoading] = useState(false);
    const [catsList, SetlistingCats] = useState([]);
    const [catidsclass, setCatidsclass] = useState("");
    const [catidsbaseclass, setCatidsBaseclass] = useState("");
    const [catidssubclass, setCatidsSubclass] = useState("");

    const fetchData = useCallback(async (params = {}) => {
        setCatsLoading(true);
        try {
            const response = await apiService.getRequest("/bookmark/sidebar");
            if (response && response.success === true) {
                SetlistingCats(response.data); 
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        }catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setCatsLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    const handleKbaseClick = (kBaseId) => {
        setCatidsBaseclass(kBaseId);   
        setCatidsclass("");
        setCatidsSubclass("");
    };
    const handleCategoryClick = (categoryId) => {
        setCatidsSubclass(categoryId);
        setCatidsclass("");
    };
    const handleSubCategoryClick = (subCategoryId) => {
        setCatidsclass(subCategoryId);
    };
    const fetchArticles = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {base_id: catidsbaseclass,category_id: catidssubclass , subcategory_id: catidsclass  ,...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/bookmark/list?${queryString}`);
            if (response && response.success === true) {
                setArticles(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            localStorage.removeItem('knowledgeBackId');
            localStorage.removeItem('knowledgeCatBackId');
            localStorage.removeItem('knowledgeKbaseBackId');
            setLoading(false);
        }
    }, [ catidsbaseclass, catidsclass, catidssubclass]);
  
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchArticles({ page: newPage });  
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchArticles({ search: searchQuery });
    };

    useEffect(() => {
        fetchArticles();
    }, [fetchArticles]);

    const handleSave = async (saveid) => {
        try {
            const params = ({
                article_id : saveid
            })
            const response = await apiService.postRequest('/bookmark/add',params);
            if(response && response.success === true){
                fetchArticles({ page: currentPage, search: searchQuery });  
                fetchData();
                toast(response.message || 'Bookmarked successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to save job");
        }
    };
    const handleRemoveSave = async (saveid) => {
        try {
            const params = ({
                article_id : saveid
            })
            const response = await apiService.postRequest('/bookmark/remove',params);
            if(response && response.success === true){
                fetchArticles({ page: currentPage, search: searchQuery });  
                fetchData();
                toast(response.message || 'Remove Bookmark successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to Unsave job");
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <div className="d-lg-block d-none"> 
                <ResizableBox 
                    className="knowledge-category"
                    width={400}    
                    height={Infinity}  
                    minConstraints={[400, Infinity]}
                    maxConstraints={[window.innerWidth - 800, Infinity]}
                    axis="x"
                    resizeHandles={['e']}
                    >
                    <div className='klgcategory_main dragging_cats'>
                        <div className="knowledge-category-content">
                            <div className='d-flex flex-column'>
                                {catsloading ? 
                                <div className='d-flex justify-content-center w-100'>
                                    <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                </div> :<>
                                    <Accordion>
                                    {catsList && catsList.length > 0 ? (
                                        catsList && catsList.map((catsListings,index) => (
                                        <Accordion.Item eventKey={index} key={catsListings.id}>
                                            <Accordion.Header 
                                            onClick={()=> handleKbaseClick(catsListings.id)} className={catidsbaseclass && catidsbaseclass === catsListings.id ? 'clicked_boldarticle' : ''}
                                            ><div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsListings.name}</div>
                                            <span style={{fontWeight:"600"}} className='article_countshow'>{catsListings.articles_count || "0"}</span>
                                            </Accordion.Header>
                                            <Accordion.Body> 
                                                <Accordion defaultActiveKey="0">
                                                {catsListings && catsListings.categories && catsListings.categories.length > 0 ? (
                                                    catsListings.categories && catsListings.categories.map((catsmainListings,index) => (
                                                    <Accordion.Item eventKey={index} key={catsmainListings.id}>
                                                        <Accordion.Header 
                                                            onClick={()=> handleCategoryClick(catsmainListings.id)} className={catidssubclass && catidssubclass === catsmainListings.id ? 'clicked_boldarticle' : ''}
                                                            >
                                                                <div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsmainListings.name}</div>
                                                            <span className='article_countshow'>{catsmainListings.articles_count || "0"}</span>
                                                            </Accordion.Header>
                                                        <Accordion.Body className='ps-0'>  
                                                        <div className='d-flex flex-column'>
                                                            {catsmainListings && catsmainListings.subcategories && catsmainListings.subcategories.length > 0 ? (
                                                                catsmainListings.subcategories && catsmainListings.subcategories.map((sublistings) => (
                                                                <span 
                                                                    key={sublistings.id} 
                                                                    onClick={() => handleSubCategoryClick(sublistings.id)}
                                                                    className={catidsclass && catidsclass === sublistings.id ? 'clicked_boldarticle d-flex align-items-center' : 'd-flex align-items-center'}
                                                                >
                                                                    <div className='div_kbacategory_listwidth'>{sublistings.name}</div>
                                                                    <span className='article_countshow'>{sublistings.articles_count || "0"}</span>
                                                                </span>))
                                                                ) : (
                                                                    <div className="w-100 d-flex justify-content-center">
                                                                        <p>No data to display</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                    ))
                                                ) : (
                                                    <div className="w-100 d-flex justify-content-center mt-4">
                                                        <p>No data to display</p>
                                                    </div>
                                                )}
                                                </Accordion>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        ))
                                        ) : (
                                            <div className="w-100 d-flex justify-content-center mt-4">
                                                <p>No data to display</p>
                                            </div>
                                        )}
                                    </Accordion>
                                </>}
                            </div>
                        </div>
                    </div>
                </ResizableBox>
            </div> 
            <div className="d-lg-none d-block">
                <div className={isVisible !== true ? 'hide_mobitr' : 'show_mobitr'}>
                    <div className='klgcategory_main dragging_cats'>
                        <div className='d-flex w-100 justify-content-end'>
                            <button className='d-lg-none closecat_btn' onClick={closeElement}><FontAwesomeIcon icon={faXmark} /></button>
                        </div>
                        <div className="knowledge-category-content">
                            <div className='d-flex flex-column'>
                                {catsloading ? 
                                <div className='d-flex justify-content-center w-100'>
                                    <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                </div> :<>
                                    <Accordion>
                                    {catsList && catsList.length > 0 ? (
                                        catsList && catsList.map((catsListings,index) => (
                                        <Accordion.Item eventKey={index} key={catsListings.id}>
                                            <Accordion.Header 
                                            onClick={()=> handleKbaseClick(catsListings.id)} className={catidsbaseclass && catidsbaseclass === catsListings.id ? 'clicked_boldarticle' : ''}
                                            ><div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsListings.name}</div>
                                            <span style={{fontWeight:"600"}} className='article_countshow'>{catsListings.articles_count || "0"}</span>
                                            </Accordion.Header>
                                            <Accordion.Body> 
                                                <Accordion defaultActiveKey="0">
                                                {catsListings && catsListings.categories && catsListings.categories.length > 0 ? (
                                                    catsListings.categories && catsListings.categories.map((catsmainListings,index) => (
                                                    <Accordion.Item eventKey={index} key={catsmainListings.id}>
                                                        <Accordion.Header 
                                                            onClick={()=> handleCategoryClick(catsmainListings.id)} className={catidssubclass && catidssubclass === catsmainListings.id ? 'clicked_boldarticle' : ''}
                                                            >
                                                                <div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsmainListings.name}</div>
                                                            <span className='article_countshow'>{catsmainListings.articles_count || "0"}</span>
                                                            </Accordion.Header>
                                                        <Accordion.Body className='ps-0'>  
                                                        <div className='d-flex flex-column'>
                                                            {catsmainListings && catsmainListings.subcategories && catsmainListings.subcategories.length > 0 ? (
                                                                catsmainListings.subcategories && catsmainListings.subcategories.map((sublistings) => (
                                                                <span 
                                                                    key={sublistings.id} 
                                                                    onClick={() => handleSubCategoryClick(sublistings.id)}
                                                                    className={catidsclass && catidsclass === sublistings.id ? 'clicked_boldarticle d-flex align-items-center' : 'd-flex align-items-center'}
                                                                >
                                                                    <div className='div_kbacategory_listwidth'>{sublistings.name}</div>
                                                                    <span className='article_countshow'>{sublistings.articles_count || "0"}</span>
                                                                </span>))
                                                                ) : (
                                                                    <div className="w-100 d-flex justify-content-center">
                                                                        <p>No data to display</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                    ))
                                                ) : (
                                                    <div className="w-100 d-flex justify-content-center mt-4">
                                                        <p>No data to display</p>
                                                    </div>
                                                )}
                                                </Accordion>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        ))
                                        ) : (
                                            <div className="w-100 d-flex justify-content-center mt-4">
                                                <p>No data to display</p>
                                            </div>
                                        )}
                                    </Accordion>
                                </>}
                            </div>
                        </div>
                    </div>
                </div> 
            </div> 
            <div className='content_container_articals_drag' style={{ flexGrow: 1 }}>
                <Grid size={{sm:12}} container className="main_jobseeker" style={{background:"#fff"}}>
                    <Grid size={{sm:12}} container alignItems="center">
                        <Grid size={{xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Knowledge Article</h3>
                            <span>
                                <b onClick={() => navigate("/dashboard")}>Dashboard</b> 
                                <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                                <b onClick={() => navigate("/knowledge")}>All Article</b> 
                                <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                                My Bookmarks
                            </span>
                        </Grid>
                        <button onClick={toggleVisibility} className='d-lg-none main_category_btn'>
                            Category  
                        </button>
                        <Grid size={{md:12,xs:12}} container justifyContent="space-between" alignItems="center" className="my-4">
                            <h4 className='mb-0' style={{fontWeight:"600"}}>My Bookmarks</h4>
                            <Grid size={{md:5.5,sm:6.5,xs:12}} container flexDirection="column">
                            <div className="d-flex jobseekersearch my-3" style={{ position: "relative" }}>
                                <div className="col-2">
                                    <FontAwesomeIcon className="iconcol" icon={faMagnifyingGlass} />
                                </div>
                                <div className='col-7'>
                                    <input type='text' placeholder='search'
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleSearch(); // Trigger search on Enter key press
                                            }
                                        }}
                                    />
                                </div>
                                <div className='col-3'>
                                    <button onClick={handleSearch}>Search</button>
                                </div>
                            </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{sm:12}} container justifyContent="center" className="mb-4">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {articles && articles.length > 0 ? (
                            articles && articles.map((article) => ( 
                            <Grid key={article.id} size={{sm:12}} container justifyContent="center" className="knowledge_lister my-4">
                                <span style={{cursor:"pointer"}} className='questionskn' onClick={() => navigate(`/knowledge-article/${article.format_id}`)}><b className="articleformat_id">{article.format_id}</b> {article.title}</span>
                                <span className='w-100 mb-3'>
                                    {article.short_description
                                    ? article.short_description.slice(0, 300) + (article.short_description.length > 300 ? "..." : "")
                                    : "No Data"}
                                </span>
                                <Grid size={{xs:12}} container className="span_griders">
                                    <span><FontAwesomeIcon icon={faUser} className='icon_kn'/><small>Authored by :</small>{article.author.name}</span>
                                    <span><FontAwesomeIcon icon={faUsers} className='icon_kn'/><small>Group :</small>{article.owned_by_group}</span>
                                    <span><FontAwesomeIcon icon={faEye} className='icon_kn'/>{article.view_count}</span>
                                    <span><FontAwesomeIcon icon={faHandshake} className='icon_kn'/>{article.helpful_true_count} Helpful</span>
                                    <span><FontAwesomeIcon icon={faHandshakeSimpleSlash} className='icon_kn'/>{article.helpful_false_count} UnHelpful</span>
                                    {article.is_bookmarked ?
                                        <span style={{cursor:"pointer"}} onClick={() => handleRemoveSave(article.id)}><img style={{width:"18px",marginRight:"10px"}} src={require("../../assets/sample/save_tagpink.svg").default} alt="save"/>Bookmarked</span>:
                                        <span style={{cursor:"pointer"}} onClick={() => handleSave(article.id)}><FontAwesomeIcon icon={faBookmark} className='icon_kn'/>Bookmark</span>
                                    }
                                    <span><FontAwesomeIcon icon={faCalendar} className='icon_kn'/>{article.created_at}</span>
                                    <Rating className='rating_spanhiders' disabled value={JSON.parse(article.overall_rating)} />
                                </Grid>
                            </Grid>
                            ))
                        ) : ( 
                            <div className="w-100 d-flex justify-content-center mt-4">
                                <p>No data to display</p>
                            </div>
                        )}
                    </>}
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                        <button className='arrowpaginate' 
                            onClick={() => handlePageChange(currentPage - 1)} 
                            disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        {paginatedata && (
                            <div className="pagination">
                                {(() => {
                                const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                const pages = [];
                                const start = Math.max(2, currentPage - 2);
                                const end = Math.min(totalPages - 1, currentPage + 2);

                                // Always show first page
                                pages.push(
                                    <button
                                    key={1}
                                    onClick={() => handlePageChange(1)}
                                    className={currentPage === 1 ? 'active' : ''}
                                    >
                                    1
                                    </button>
                                );

                                if (start > 2) {
                                    pages.push(<span key="start-ellipsis">...</span>);
                                }

                                for (let i = start; i <= end; i++) {
                                    pages.push(
                                    <button
                                        key={i}
                                        onClick={() => handlePageChange(i)}
                                        className={currentPage === i ? 'active' : ''}
                                    >
                                        {i}
                                    </button>
                                    );
                                }

                                if (end < totalPages - 1) {
                                    pages.push(<span key="end-ellipsis">...</span>);
                                }

                                if (totalPages > 1) {
                                    pages.push(
                                    <button
                                        key={totalPages}
                                        onClick={() => handlePageChange(totalPages)}
                                        className={currentPage === totalPages ? 'active' : ''}
                                    >
                                        {totalPages}
                                    </button>
                                    );
                                }

                                return pages;
                                })()}
                            </div>
                            )}

                        <button className='arrowpaginate'
                            onClick={() => handlePageChange(currentPage + 1)} 
                            disabled={currentPage === paginatedata.last_page}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    </div>
  )
}

export default KnowledgeArticleBookmark
